import React, { Component } from 'react';
import ThreeOptions from './ThreeOptions';

class Step6 extends Component {
    render() {
        return (

            <div className="card card-body">

                <div className="form-group">
                    <div className="row">
                        <div className='col-sm-12 h5'>COMMUNICATION INSPECTION
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="commActivePassive">Monitoring Connection Configuration – Active OR Passive</label>
                                <select id="commActivePassive" name="commActivePassive" className="custom-select" required="required">
                                    <option selected disabled>-</option>
                                    <option value="Passive">PASSIVE</option>
                                    <option value="Active">ACTIVE</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-sm-12 ">
                            {/* <ThreeOptions
                                name="commPaths"
                                label="Communication Path(s)"
                            /> */}
                            <div className="form-group">
                                <label htmlFor="commPaths">Communication Path(s)</label>
                                {/* <textarea id="commPaths" name="commPaths" cols="40" rows="5" required="required" className="form-control here" /> */}
                                <select id="commPaths" name="commPaths" className="custom-select" required="required">
                                    <option selected disabled>-</option>
                                    <option value="GSM Only">GSM ONLY</option>
                                    <option value="GSM And Landline">GSM AND LANDLINE</option>
                                    <option value="GSM And IP">GSM AND IP</option>
                                    <option value="IP And Landline">IP AND LANDLINE</option>
                                    <option value="IP and GSM">IP AND GSM</option>
                                    <option value="IP Supervised">IP SUPERVISED</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div >

            </div >
        );
    }
}

export default Step6;



// WEBPACK FOOTER //
// ./src/components/Step6.js